import React from 'react';

export default function ImpersonationBanner({ impersonatedUserName, impersonatedUserId, onStopImpersonating, translations }) {
  const handleStopImpersonating = async () => {
    try {
      const response = await fetch('/admin/stop_impersonating', {
        method: 'DELETE',
        headers: {
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
          'Accept': 'application/json'
        },
      });

      if (response.ok) {
        const data = await response.json();
        // Navigate to root path after successful stop
        window.location.href = '/';
      } else {
        console.error('Failed to stop impersonating');
      }
    } catch (error) {
      console.error('Error stopping impersonation:', error);
    }
  };

  return (
    <div className="bg-red-600 text-white px-4 py-2 flex items-center justify-between shadow-lg">
      <div className="flex items-center space-x-4">
        <span className="font-bold">
          {translations.impersonation?.banner_title || '⚠️ Admin Impersonation Mode'}
        </span>
        <span>
          {translations.impersonation?.viewing_as?.replace('%{name}', impersonatedUserName).replace('%{id}', impersonatedUserId) ||
            `You are viewing as ${impersonatedUserName} (ID: ${impersonatedUserId})`}
        </span>
      </div>
      <button
        onClick={handleStopImpersonating}
        className="bg-white text-red-600 hover:bg-red-50 px-4 py-1 rounded font-medium transition-colors"
      >
        {translations.impersonation?.stop_button || 'Switch Back to Admin'}
      </button>
    </div>
  );
}
